import { getLocalStorageItem, setLocalStorageItem } from "@/utils/storageUtil";

/** Tolerates junk, since the legacy windfall search bar writes this key too. */
export const readSearchHistory = (): string[] => {
  const storedValue = getLocalStorageItem(SEARCH_HISTORY_STORAGE_KEY, []);
  if (!Array.isArray(storedValue)) {
    return [];
  }
  return storedValue.filter((entry): entry is string => typeof entry === "string");
};

/**
 * Returns the new list so callers can render it without re-reading storage -- or the untouched
 * old list when the write was rejected, so the dropdown never shows a term that is gone on reload.
 */
export const addSearchTerm = (searchTerm: string | null | undefined): string[] => {
  const searchHistory = readSearchHistory();
  const trimmedSearchTerm = searchTerm?.trim();
  if (!trimmedSearchTerm) {
    return searchHistory;
  }

  const withoutPreviousEntries = searchHistory.filter(
    (entry) => entry.toLowerCase() !== trimmedSearchTerm.toLowerCase(),
  );
  const updatedSearchHistory = [trimmedSearchTerm, ...withoutPreviousEntries].slice(0, MAX_SEARCH_HISTORY);

  if (!setLocalStorageItem(SEARCH_HISTORY_STORAGE_KEY, updatedSearchHistory)) {
    return searchHistory;
  }
  return updatedSearchHistory;
};

export const removeSearchTerm = (searchTerm: string): string[] => {
  const searchHistory = readSearchHistory();
  const updatedSearchHistory = searchHistory.filter((entry) => entry.toLowerCase() !== searchTerm.toLowerCase());

  if (!setLocalStorageItem(SEARCH_HISTORY_STORAGE_KEY, updatedSearchHistory)) {
    return searchHistory;
  }
  return updatedSearchHistory;
};

/** The legacy windfall search bar reads and writes this exact key. Do not rename. */
export const SEARCH_HISTORY_STORAGE_KEY = "net32LocalSearchHistory";

/** Stored, not shown -- the dropdown renders MAX_SEARCH_HISTORY_DISPLAY of these. */
export const MAX_SEARCH_HISTORY = 12;

export const MAX_SEARCH_HISTORY_DISPLAY = 6;
